// Partners page text (Markdown, rendered with helpers/faq-format.js). Written from undetectable.io's site and docs.
// Links come from helpers/partners.js, so the affiliate code stays in one place.
import { UNDETECTABLE } from '@/helpers/partners';

export const UNDETECTABLE_PAGE = `## What is Undetectable.io?

Undetectable is an anti-detect browser for Windows and Mac. It runs many separate browser profiles side by side. Each profile looks like its own device, with its own fingerprint, cookies and proxy, so accounts kept in different profiles aren't linked to each other.

It can store profiles on your computer or in the cloud, so a team can share them, and it has an API for automation.

## Why use it with ProxyWarehouse?

- Give every profile its own ProxyWarehouse mobile proxy
- Keep each account's fingerprint, cookies and IP separate
- Change your proxy's IP from inside the browser with your rotation link
- Undetectable say it's tested on over 50 platforms, including Google, Facebook, Instagram, TikTok and Amazon

## Plans

- **Free:** 5 cloud profiles and unlimited local profiles, for one user. Enough to try it with your proxy.
- **Base, Professional and Custom:** more cloud profiles, extra team members, proxy and profile import / export, bulk profile creation and API access.

Current prices are on [Undetectable's pricing page](${UNDETECTABLE.pricingUrl}).

## How to add your ProxyWarehouse proxy

:::steps
Copy your proxy | In **My Proxy**, copy the HTTP or SOCKS5 line with your login.
Open a profile | In Undetectable, create a profile and open its proxy settings.
Paste the details | Choose HTTP or SOCKS5 and enter the host, port, username and password.
Add the rotation link | Paste the **Change IP** link from My Proxy into the IP change link field.
* Rotate on launch | Optional: tick "Use link for IP change" to get a fresh IP each time the profile starts.
:::

Undetectable's own step-by-step guide: [mobile proxies in an anti-detect browser](${UNDETECTABLE.guideUrl}).

## Tips for mobile proxies

- Use one proxy per profile, and keep each account on the same profile.
- Keep the profile's time zone and language in line with the proxy's country.
- Changing the IP takes the proxy offline for 10–20 seconds, so wait before loading pages.
- Leave at least 5 minutes between IP rotations.

## Quick answers

:::qa
### Is Undetectable.io free?
There's a free plan with 5 cloud profiles and unlimited local profiles for one user. Paid plans add more profiles, team members and automation.
### Does it work with ProxyWarehouse mobile proxies?
Yes. Add your HTTP or SOCKS5 details to a profile, and your Change IP link if you want to rotate from inside the browser.
### Which computers does it run on?
Windows and Mac.
### Do I need an anti-detect browser to use my proxy?
No. Any browser or app can use your proxy. An anti-detect browser helps when you manage several accounts and need each one kept separate.
### Who do I ask for help with Undetectable?
Undetectable's own support team helps with the browser. We're happy to help with the proxy side on Live support.
:::

:::note
**5% off your proxies:** sign up to Undetectable.io through our link and choose a paid plan, then let us know in Live support chat and we'll send you a 5% discount code for your proxies.
:::
`;
